import Cookie from 'js-cookie';

export default function getSessionId() {
    return Cookie.get("siod");
}
